import React from 'react';
import LogicoHistoryComponent from './LogicoHistoryComponent';

export default (props) => {
    return <LogicoHistoryComponent location={props.location} />;
}
